import { storage } from "../../config/firebase/firebase-config";
import { ApiResponse } from "../ApiResponse";

export const create = async(
  file: File,
  path: string
): Promise<ApiResponse> => {
  try {
    const storageRef = storage.ref(path);
    const snapshot = await storageRef.put(file);
    const downloadURL = await snapshot.ref.getDownloadURL();

    return {
      ok: true,
      data: {
        url: downloadURL,
        path: snapshot.ref.fullPath,
        name: snapshot.ref.name,
        size: snapshot.totalBytes
      },
      message: "Recurso creado con exito."
    };
  } catch (exception) {
    return {
      ok: false,
      data: null,
      message: exception
    };
  }
};